import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Toggle = (props) => {
  const {
    defaultChecked,
    disabled,
    forwardedRef,
    id,
    label,
    name,
    onChange,
    className,
    ...passProps
  } = props;

  return (
    <div className={classNames('gn-toggle', className)}>
      <span>{label}</span>
      <input
        id={id}
        type="checkbox"
        defaultChecked={defaultChecked}
        name={name}
        onChange={onChange}
        ref={forwardedRef}
        disabled={disabled}
        {...passProps}
      />
      <label htmlFor={id}>
          {label}
      </label>
    </div>
  );
};

Toggle.propTypes = {
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  forwardedRef: PropTypes.func,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  name: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

export default Toggle;
